



















import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { hexToU8a, isHex, stringToU8a } from '@polkadot/util';
import { blake2AsHex } from '@polkadot/util-crypto';
import DisabledInput from '@/components/shared/DisabledInput.vue';

@Component({
  components: {
    DisabledInput,
  }
})
export default class HashDataMessage extends Vue {

  private data: string = '';
  private inputDataCheck: string = 'No';
  private hashedData: string = '';

  private hashData(): void {
    this.hashedData = blake2AsHex(
      isHex(this.data)
        ? hexToU8a(this.data)
        : stringToU8a(this.data),
      256)
  }

  private isHexData(): void {
    this.inputDataCheck = isHex(this.data)
      ? 'Yes'
      : 'No';
  }

  private toast(message: string): void {
    this.$buefy.toast.open(message);
  }
}
